module.exports = __webpack_public_path__ + "static/condor-above-hills-34e27dbfa034423c89d5a8c50691f0aa.jpg";